import './index.scss'
import coverHtml from './index.html'
import { parseDom } from 'src/frontend-lib/tools/domUtil'

/**
 * 音频播放封面组件
 */
export default class AudioCoverComponent {
  // cover el
  $el = null
  $bg = null
  // cover image
  $cover = ''

  /**
   * @constructor 音频播放组件构造函数
   */
  constructor(cover) {
    this.html = parseDom(coverHtml)
    this.$cover = cover
    this.$el = this.html.querySelector('.audio-cover-content img')
    this.$bg = this.html.querySelector('.audio-cover-component-bg')
  }

  createEl(el) {
    this.hide()
    this.setCover(this.$cover)
    el.appendChild(this.html)
  }

  playing() {
    this.show()
  }

  waiting() {
    this.hide(false)
  }

  pause() {
    this.hide(false)
  }

  ended() {
    this.hide()
  }

  /**
   * 设置背景图
   */
  _setCover() {
    const el = this.$el
    const bg = this.$bg
    const cover = this.$cover
    if (el instanceof HTMLElement) {
      el.src = cover
    }
    if (bg instanceof HTMLElement) {
      bg.style.backgroundImage = 'url('.concat(cover, ')')
    }
  }

  _setSize(size) {
    const el = this.$el
    if (el instanceof HTMLElement) {
      el.style.backgroundSize = size
    }
  }

  _show(el) {
    if (el instanceof HTMLElement) {
      el.removeAttribute('hidden')
    }
  }

  _hide(el) {
    if (el instanceof HTMLElement) {
      el.setAttribute('hidden', true)
    }
  }

  _play(el) {
    if (el instanceof HTMLElement) {
      el.removeAttribute('paused')
    }
  }

  _stop(el) {
    if (el instanceof HTMLElement) {
      el.setAttribute('paused', true)
    }
  }

  setCover(url) {
    this.$cover = url
    return this._setCover()
  }

  show() {
    const el = this.html
    this._show(el)
    this._play(el)
  }

  /**
   * 隐藏cover
   * @param { boolean | undefined } flag 隐藏整个
   */
  hide(flag) {
    const el = this.html
    flag !== false && this._hide(el)
    this._stop(el)
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/AudioCoverComponent/index.js